export default __webpack_public_path__ + "static/media/542.3b6e3991.png";